import { Component, Vue } from 'vue-property-decorator';

@Component<DefaultDialog>({
  components: {
  },
})
export default class DefaultDialog extends Vue {
  protected isLoading = false;

  public handleLoader(loader: boolean): void {
    this.isLoading = loader;
  }

  public close(): void {
    this.$emit('close');
  }
}
